import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Mesto } from './mesto';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-mesto-update',
  templateUrl: './mesto-update.component.html'
})
export class MestoUpdateComponent extends BaseUpdateComponent<Mesto> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'MESTO.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(100), 'maxlength', 'MESTO.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("PostBroj", Validators.required, 'required', 'MESTO.POSTBROJ.VALIDATION.REQUIRED');
    this.addValidatorToFc("PostBroj", Validators.maxLength(5), 'maxlength', 'MESTO.POSTBROJ.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("OpstinaID", Validators.required, 'required', 'MESTO.OPSTINAID.VALIDATION.REQUIRED');
  }

}
